import { Area, ChatPayload, GetChatResponse } from "../interfaces/api/get-web-chat";
import { Conversation, GetConversationsResponse } from "../interfaces/api/get-conversations";
import { GetMessagesResponse, WebMessage } from "../interfaces/api/get-messages";
import { PostAreaResponse } from "../interfaces/api/post-area";
import { PutChatResponse, ResponsePayload } from "../interfaces/api/put-web-chat";

export const chatMapper = {
  mapResponseToChat(
    response: GetChatResponse
  ): ChatPayload {
    return { chat: response.payload.chat, areas: response.payload.areas };
  },
  mapResponseToChatConfig(
    response: PutChatResponse
  ): ResponsePayload {
    return { chat: response.payload.chat };
  },
  mapResponseToConversations(
    response: GetConversationsResponse
  ): { conversations: Conversation[] } {
    return { conversations: response.payload.conversations };
  },
  mapResponseToMessages(
    response: GetMessagesResponse
  ): { messages: WebMessage[] } {
    return { messages: response.payload.messages };
  },
  mapResponseToArea(
    response: PostAreaResponse
  ): { area: Area } {
    return { area: response.payload.area };
  },
};
